import { TEDCustomDateTimeParser } from './TEDCustomDateTimeParser';
import { TEDParseDateTimeMode } from '../FormatterTypes';

export class TEDParseDateTimeGeneral extends TEDCustomDateTimeParser {
  public static getInstance(): TEDParseDateTimeGeneral {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseDateTimeGeneral;

  public mode() {
    return TEDParseDateTimeMode.pdmGeneral;
  }
}
